import $ from "jquery"
import "slick-carousel-latest"


var devSllider = $('.section--available_developer_wrapper');
devSllider.on('init', function (event, slick) {
    var slidesToShow = slick.options.slidesToShow;
    $('.pagination .total-devs').html(slick.slideCount);
    $('.pagination .current-devs').html(slidesToShow);
    $('.slider-nav').show();
    if(slick.slideCount <= slidesToShow){
        $('.slider-nav').hide();
    }
});

devSllider.slick({
    slidesToShow: 4,
    slidesToScroll: 4,
    autoplay: false,
    autoplaySpeed: 3000,
    arrows: false,
    dots: false,
    responsive: [
        {
            breakpoint: 1025,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
            }
        },
        {
            breakpoint: 769,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            }
        },
        {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            }
        },
    ]
});

$('.prev-devs').on('click',function(e){ 
    //e.preventDefault(); 
    devSllider.slick('slickPrev');
} );

$('.next-devs').on('click', function(e){
    //e.preventDefault(); 
    devSllider.slick('slickNext');
} );

// On before slide change
devSllider.on('afterChange', function(event, slick, currentSlide){
    var slidesToShow = slick.options.slidesToShow;
    if(currentSlide <= slick.slideCount){
        currentSlide = currentSlide + slidesToShow;
        if(currentSlide >= slick.slideCount){
            currentSlide = currentSlide - (currentSlide -  slick.slideCount);
        }
    }

    $('.pagination .current-devs').html(currentSlide);

    $('.slider-nav').show();
    if(slick.slideCount <= slidesToShow){
        $('.slider-nav').hide();
    }
});